// Lets code that's about to leave the page (a Microsoft sign-in redirect) save settings
// changes still waiting for their debounced upload – otherwise a change made just before
// (e.g. switching a widget on, then "Connect Power BI") is lost when the account's copy is
// loaded on return. useSettingsSync registers the real flush while it runs.

let flush: (() => Promise<void>) | null = null;

export function registerFlush(fn: (() => Promise<void>) | null): void {
  flush = fn;
}

/** Saves pending settings now (waiting at most `timeoutMs`). */
export function flushSettings(timeoutMs = 3000): Promise<void> {
  if (!flush) return Promise.resolve();
  return Promise.race([flush().catch(() => undefined), new Promise<void>((r) => setTimeout(r, timeoutMs))]);
}
